export default __webpack_public_path__ + "static/media/howItWorksClient2.1bb3cfaf.png";